import { render } from "./InputIncome.vue?vue&type=template&id=c6865326"
import script from "./InputIncome.vue?vue&type=script&lang=js"
export * from "./InputIncome.vue?vue&type=script&lang=js"
script.render = render

export default script